export function translateAuthErrors(error:any){

    let translatedMessage;

    switch(error.code){

        case "auth/email-already-exists":
            translatedMessage= "Email already in use by another account."
            break
        case "auth/invalid-display-name":
            translatedMessage= "It appears you have an invalid character in your name. Please correct it and try again"
            break
        case "auth/invalid-email":
            translatedMessage = "The email you provided is invalid. Please try again with a valid email."
            break
        case "auth/invalid-password":
            translatedMessage = "The password you provided is invalid. Please try again with a valid password."
            break
        case "auth/wrong-password":
            translatedMessage = "Wrong email or password. Please try again."
            break
        case "auth/too-many-requests":
            translatedMessage = "Too many wrong password attempts. Your account has been deactivated. Please contact customer support."
            break
        case "auth/invalid-phone-number":
            translatedMessage = "The phone number you provided is invalid. Please try again with a valid phone number."
            break
        case "auth/phone-number-already-exists":
            translatedMessage = "The phone number you provided is already in use by another account"
            break
        case "auth/network-request-failed":
            translatedMessage = "Please check your internet connectivity"
            break
        case "auth/user-not-found":
            translatedMessage = "You have no account with us. Please register."
            break
        case "auth/email-already-in-use":
            translatedMessage = "Email already in use by another account."
            break
        default:
            translatedMessage = "Sorry unexpected error occurred. Please try again or contact customer support."
        
    }

    return translatedMessage
    
}